module.exports = __webpack_public_path__ + "static/img/glyphicons-halflings-regular.8988968.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 858
// module chunks = 0